import { createContext, useContext } from "react";

// The list of posts a PostCard belongs to (feed order) + how to fetch the next page.
// Provided by feed pages; consumed by the PC theater to step to the next/previous video.
export const PostListContext = createContext(null);
export const usePostList = () => useContext(PostListContext);

// Mirrors CommentModal.theaterMediaOf: a post whose theater stage is the single video
// (albums mixing photos + videos are a different stage and are skipped).
export const isVideoPost = (p) => {
  if (!p || !p.video_url || p.ad) return false;
  const album = Array.isArray(p.album) && p.album.length > 1 && p.album.some((m) => m.type === "video");
  return !album;
};

// Neighbours of `currentId` among the video posts of `posts` (feed order).
export const videoNeighbours = (posts, currentId) => {
  const vids = (posts || []).filter(isVideoPost);
  const i = vids.findIndex((p) => p.id === currentId);
  if (i < 0) return { prev: null, next: null, known: false };
  return { prev: i > 0 ? vids[i - 1] : null, next: i < vids.length - 1 ? vids[i + 1] : null, known: true };
};
